import { render, staticRenderFns } from "./Coupons.vue?vue&type=template&id=29d1840f&"
import script from "./Coupons.vue?vue&type=script&lang=js&"
export * from "./Coupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports